import {
  SlTreeItem
} from "./chunk.JVZ7GUNC.js";

// src/components/tree-item/tree-item.ts
var tree_item_default = SlTreeItem;
SlTreeItem.define("sl-tree-item");

export {
  tree_item_default
};
